import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import * as moment from 'moment-timezone';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { DriversService } from '../drivers-service/drivers-service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { dataURItoBlob, getAddressDetails } from 'src/app/utils/utils.common';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-create-driver',
  templateUrl: './create-driver.component.html',
  styleUrls: ['./create-driver.component.css']
})
export class CreateDriverComponent implements OnInit, OnDestroy {
  createDriverFormV2: FormGroup;
  signatureModalObj;
  status = "active";
  staffList;
  fleetList;
  driverUserId;
  submitted = false;
  fundingFormSubmitted = false;
  selectedProfileImageFile = null;
  serviceAreas;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  isSignature = false;
  corporateUsers = [];
  corporateStatus = "active";
  spaceTypeList = [];
  equipmentList = [];
  days = ['Sunday','Monday' , 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  user: any;
  timeZone: any;
  isEditRippling = false;

  constructor(
    private sharedDataService :SharedDataService,
    private equipmentService: EquipmentService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private fleetService: FleetService,
    private fb: FormBuilder,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private proTips: ProTipsServiceService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 4 && this.activatedRoute.snapshot.url[3].path === 'edit') {
      this.driverUserId = this.activatedRoute.snapshot.url[2].path;
    }


    this.createDriverFormV2 = this.fb.group({
      legalName: ['', [Validators.required, Validators.minLength(3)]],
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required, Validators.minLength(3)]],
      profileRole: ['', Validators.required],
      stationManager: ['', Validators.required],
      serviceAreas: ['', Validators.required],
      costCenter: ['', Validators.required],
      employeeId: ['', Validators.required],
      type: ['', Validators.required],
      gender: [''],
      email: ['', Validators.required],
      contactNumber: ['', Validators.required],
      password: ['', Validators.required],
      startingPointAddress: this.fb.group({
        address: ['', Validators.required],
        latitude: [0, Validators.required],
        longitude: [0, Validators.required],
      }),

      address: ['', Validators.required],
      latitude: [0, Validators.required],
      longitude: [0, Validators.required],
      preStartDate: [''],
      startDate: ['', Validators.required],
      preEndDate: ['', Validators.required],
      endDate: ['', Validators.required],
      scheduleShells: ['', Validators.required],
      proficiency: [[], Validators.required],
      competency: ['', Validators.required],
      specialRequests: [''],
      limitation: [''],
      fundingSources: this.fb.array([]),
      profileImageURL: [''],
      allowIncentive:[false],
      isAutoTimestamp:[false],

      zipCode: ["",],
      state: [""],
      city: [""],
      driverSignatureImage: [""],
      driverLicenseNumber: ["", Validators.required],
      ripplingWorkerId: [""],
      accountStatus: ['active', Validators.required],
      shifts: this.fb.array([]),
      assistShifts: this.fb.array([]),
    });

    // Add Shifts
    this.addPreShifts()
    this.addAssistShifts();

    this.getStaffList();
    this.getFleetList();
    this.getServiceAreas();
    this.getcorporateUsers();
    this.getSpaceTypeList();
    this.getEquipmentList();

    if (this.driverUserId) {
      this.getDriverData();
    }
    window.addEventListener("keydown", this.initializeRipplingShortcut);
  }

  addAssistShifts() {
    const items = this.createDriverFormV2.get('assistShifts') as FormArray;
    for (const day of [0, 1, 2, 3, 4, 5, 6]) {
      items.push(
        this.fb.group({
          perCheckin: [moment('00:00', "HH:mm")],
          preCheckout: [moment('23:59', "HH:mm")],
          checkin: ['00:00', Validators.required],
          checkout: ['23:59', Validators.required],
          shiftAlign: ['opener', Validators.required],
          day: [day, Validators.required],
          isEnabled: [false]
        })
      );
    }
  }

  updateAssistShift(preAssistShifts?) {
    const items = this.createDriverFormV2.get('assistShifts') as FormArray;
    if (preAssistShifts) {
      for (let [index, assistShift] of preAssistShifts.entries()) {
        items.at(index).patchValue({
          perCheckin: moment(assistShift.checkin, "HH:mm"),
          preCheckout: moment(assistShift.checkout, "HH:mm"),
          checkin: assistShift.checkin,
          checkout: assistShift.checkout,
          shiftAlign: assistShift.shiftAlign,
          day: assistShift.day,
          isEnabled: assistShift.isEnabled
        });
      }
    }
  }

  // --assist shift---
  // Event handlers for assist shift start and end
onChangeAssistShiftStart(evt, assistShift) {
  assistShift.patchValue({
    checkin: moment(evt).format("HH:mm")
  });
}

onChangeAssistShiftEnd(evt, assistShift) {
  assistShift.patchValue({
    checkout: moment(evt).format("HH:mm")
  });
}

// Getter for assistShifts
get assistShiftsForm() {
  return this.createDriverFormV2.get('assistShifts') as FormArray;
}

// Single assist day check (validation)
singleAssistShift() {
  let isAssistDayShiftEnabled = false;
  for (let item of this.createDriverFormV2.value.assistShifts) {
    if (item.isEnabled) {
      isAssistDayShiftEnabled = true;
      break;
    }
  }
  return isAssistDayShiftEnabled;
}

  getcorporateUsers() {
    this.corporateUsers = [];
    this.corporateService
      .getCorporateUsers(this.corporateStatus)
      .subscribe(data => {
        if (data && data.length) {
          this.corporateUsers = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getDriverData() {
    this.driverService
      .getDriversByID(this.driverUserId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {

          this.createDriverFormV2.patchValue({
            ...data,
            password: '',
            preStartDate: data.startDate ? moment(data.startDate) : '',
            preEndDate: data.endDate ? moment(data.endDate) : "",
          });
          if (data.ripplingWorkerId) {
            this.createDriverFormV2.get('ripplingWorkerId').disable();
          }

          if(data.fundingSources)
          this.addFundingSource(data.fundingSources);


          this.createDriverFormV2.controls.password.clearValidators()
          this.createDriverFormV2.controls.password.updateValueAndValidity();

          // update day Shift
          if (data.shifts) {
            this.updateShift(data.shifts);
          }
        }
      });
  }



  onChangeStartTime(evt) {
    this.createDriverFormV2.patchValue({
      shift: {
        checkin: moment(evt).format("HH:mm")
      }
    });
  }
  onChangeEndTime(evt) {
    this.createDriverFormV2.patchValue({
      shift: {
        checkout: moment(evt).format("HH:mm")
      }
    });
  }

  getStaffList() {
  const queryParams = {
    accountStatus: 'active'
    }
    this.staffService
      .getStaffList(queryParams).subscribe(data => {
        if (data) {
          this.staffList = data.filter(staff => ["mdispatcher","mcallcenter"].includes(staff.roles));
        }
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': this.status })
      .subscribe(
        (data) => {
          if (data) {
            this.fleetList = data;
          }
        },
      );
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreas = data
          }
        });
  }

  setAddress(place) {
    this.createDriverFormV2.patchValue({
      address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng()
    });
  }

  setGarageAddress(place) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    this.createDriverFormV2.patchValue({
      zipCode: zip
    })

    this.createDriverFormV2.controls.startingPointAddress.patchValue({
      address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng()
    });
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }


  onCreateDriverV2() {
    console.log('createDriverFormV2', this.createDriverFormV2.value);
    this.submitted = true;
    if (this.createDriverFormV2.invalid || !this.singleDayShift()) return;
    const payload = this.createDriverFormV2.getRawValue();
    if (!this.driverUserId) {
      this.driverService.saveDriverV2(payload).subscribe(data => {
        if (data) {
          this.router.navigateByUrl("credentialing/drivers");
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      })
    } else {
      if (!this.createDriverFormV2.value.password) {
        delete payload.password;
      }

      this.driverService.updateDriver(payload, this.driverUserId).subscribe(data => {
        if (data) {
          this.router.navigateByUrl("credentialing/drivers");
        }
      })
    }


    this.submitted = false;

  }

  onChangeDateFundingSource(evt,fundingSource) {
    fundingSource.patchValue({
      validityRange: [evt[0].startOf('day').toISOString(), evt[1].endOf('day').toISOString()]
    })
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTips.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })

  }


  addFundingSource(preFundingSourcesList?) {

    const items = this.createDriverFormV2.get('fundingSources') as FormArray;
    if (preFundingSourcesList) {
      for (const fundingSource of preFundingSourcesList) {
        items.push(
          this.fb.group({
            name: [fundingSource.name, Validators.required],
            validityRange: [fundingSource.validityRange, Validators.required],
            preValidityRange: [[moment(fundingSource.validityRange[0]), moment(fundingSource.validityRange[1])], Validators.required],
            isAllowShowBreaks:[fundingSource.isAllowShowBreaks]
          })
        );

      }
      return;
    }
    items.push(this.fb.group({
      name: ['', Validators.required],
      validityRange: [[moment().startOf('day').toISOString(), moment().endOf('day').toISOString()], Validators.required],
      preValidityRange: [[moment().startOf('day'), moment().endOf('day')]],
      isAllowShowBreaks:[true]
    }))
  }

  selectAllFundingSource(isEnabled){
    let items = this.createDriverFormV2.get('fundingSources') as FormArray;
    if (!isEnabled) {
      for (let corporateUser of this.corporateUsers){

        const exists = items.controls.some(control => {
          return control.value.name === corporateUser._id;
        });

        if(exists){
          continue;
        }

        items.push(this.fb.group({
          name: corporateUser._id,
          validityRange: [[moment().startOf('day').toISOString(), moment().add(5,'years').endOf('day').toISOString()], Validators.required],
          preValidityRange: [[moment().startOf('day'), moment().add(5,'years').endOf('day')]],
          isAllowShowBreaks:[true]
        }));

      }
    }else{
      items.clear();
    }

  }

  removeFundingSource(index) {
    const items =  this.createDriverFormV2.get('fundingSources')as FormArray;
    items.removeAt(index);
  }

  getValidityRangeLabel(item) {
    return moment(item[0]).format("YYYY-MM-DD") + ' - ' + moment(item[1]).format("YYYY-MM-DD");
  }

  addPreShifts() {
    const items = this.createDriverFormV2.get('shifts') as FormArray;
      for (const day of [0,1,2,3,4,5,6]) {
        items.push(
          this.fb.group({
            perCheckin:  [moment().startOf('day')],
            preCheckout: [moment().endOf('day')],
            checkin: [moment().startOf('day').format("HH:mm"), Validators.required],
            checkout: [moment().endOf('day').format("HH:mm"), Validators.required],
            shiftAlign: ['opener', Validators.required],
            day: [day, Validators.required],
            isEnabled: [false]
          })
        );

      }
  }

  updateShift(preShifts?) {
    const items = this.createDriverFormV2.get('shifts') as FormArray;
    if (preShifts) {
      for (let [index, shift] of preShifts.entries()) {
        items.at(index).patchValue(
          {
            perCheckin: moment().startOf('day').hours(shift.checkin.split(":")[0]).minutes(shift.checkin.split(":")[1]).seconds(0),
            preCheckout: moment().startOf('day').hours(shift.checkout.split(":")[0]).minutes(shift.checkout.split(":")[1]).seconds(0),
            checkin: moment().startOf('day').hours(shift.checkin.split(":")[0]).minutes(shift.checkin.split(":")[1]).seconds(0).format("HH:mm"),
            checkout: moment().startOf('day').hours(shift.checkout.split(":")[0]).minutes(shift.checkout.split(":")[1]).seconds(0).format("HH:mm"),
            shiftAlign: shift.shiftAlign,
            day: shift.day,
            isEnabled: shift.isEnabled
          }
        );

      }
    }
  }


  onChangeShiftStart(evt,shift) {
    shift.patchValue({
      checkin: moment(evt).format("HH:mm")
    });
  }

  onChangeShiftEnd(evt,shift) {
    shift.patchValue({
      checkout: moment(evt).format("HH:mm")
    });
  }


  getMinDate() {
    return moment().startOf('day');
  }

  getMaxDate() {
    return moment().endOf('day');
  }
  getStartMinDate(val) {
    return moment(val);
  }

  get form() {
    return this.createDriverFormV2.controls;
  }

  get shiftForm() {
    return this.createDriverFormV2.controls.shift['controls'];
  }

  get addressForm() {
    return this.createDriverFormV2.controls.startingPointAddress['controls'];
  }

  get fundingSourceForm() {
    return  this.createDriverFormV2.get('fundingSources')as FormArray;
  }

  get shiftsForm() {
    return  this.createDriverFormV2.get('shifts')as FormArray;
  }

  openSigModal() {
    this.isSignature = true;
  }

  saveSignature(evt) {
    this.isSignature = false;
    const imageBlob = dataURItoBlob(evt);
    const imageFile = new File([imageBlob], "signature.png", { type: 'image/png' });
    const payload = {
      _id: this.driverUserId,
      driverSignatureImage: imageFile
    };
    this.driverService
      .uploadSignature(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.createDriverFormV2.patchValue({
            driverSignatureImage: data.driver.driverSignatureImage
          })
        }
      });
  }

  closeModal() {
    this.isSignature = false;
  }

  getCorporateName(id) {
    return this.corporateUsers.find(corporate => corporate._id === id);
  }

  getSpaceTypeList() {
    this.levelOfServiceService
    .getSpaceTypes({ status: 'active' })
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data ) {
        this.spaceTypeList = data;
      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  getEquipmentList() {
    let queryParams = {
      isAddon: false,
    }
    this.equipmentService
    .getEquipments(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data ) {
        this.equipmentList = data;
      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  singleDayShift(){
    let isDayShiftEnabled = false;
    for(let item of this.createDriverFormV2.value.shifts){
      if(item.isEnabled){
        isDayShiftEnabled =true;
        break;
      }
    }
    return isDayShiftEnabled;
  }

  toggleIncentive() {
    this.createDriverFormV2.patchValue({
      allowIncentive: !this.createDriverFormV2.value.allowIncentive
    });
  }

  toggleAutoTimeStamp() {
    this.createDriverFormV2.patchValue({
      isAutoTimestamp: !this.createDriverFormV2.value.isAutoTimestamp
    });
  }

  initializeRipplingShortcut = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isEditRippling = !this.isEditRippling;
      if (this.isEditRippling) {
        this.createDriverFormV2.get('ripplingWorkerId').enable();
      } else {
        this.createDriverFormV2.get('ripplingWorkerId').disable();
      }
    }
  };

  ngOnDestroy() {
  }

}



